<template>
    <div class="compensation-step">
        <span class="compensation-step__order-number">{{ orderNumber }}</span>
        <p class="compensation-step__description"
            v-html="textHtml"></p>
        <span class="compensation-step__step-arrow"
            :class="{
                'compensation-step__step-arrow--hidden': hideStepArrow
            }">
            <SvgIcon class="compensation-step__step-arrow-icon" 
                name="arrow-bottom" />
        </span>
    </div>
</template>

<script>
import SvgIcon from './SvgIcon';

export default {
    name: 'CompensationStep',
    components: {
        SvgIcon
    },
    props: {
        textHtml: {
            type: String,
            required: true
        },
        orderNumber: {
            type: Number,
            required: true
        },
        hideStepArrow: {
            type: Boolean,
            required: false,
            default: false
        }
    }

}
</script>

<style scoped lang="scss">
.compensation-step {
    $root: &;

    position: relative;

    height: 100%;
    padding: rem($gap-normal);

    border-radius: rem($border-radius-default);
    background-color: $color-card-background-secondary;

    &__order-number {
        $size-desktop: 31px;

        @include text-medium($font-weight-medium, $line-height-large);
        @include flex-all-center;

        width: rem($size-desktop);
        height: rem($size-desktop);

        color: $primary-invert;
        border-radius: 50%;
        background-color: $primary;
    }

    &__description {
        @include text-normal($font-weight-regular, $line-height-large);

        color: $primary;

        margin-top: rem($gap-normal);

        @media #{$screen-big} {
            font-size: rem($font-size-small);
        }
    }

    &__step-arrow {
        $size: $icon-size-base;
        $gap-desktop: $gap-xl;
        $gap-desktop-min: $gap-great;

        position: absolute;
        left: calc(100% + $gap-desktop / 2 - $size / 2);
        top: 50%;
        transform: translateY(-50%);

        color: $primary;

        @media #{$screen-big} {
            left: calc(100% + $gap-desktop-min / 2 - $size / 2);
        }

        @media #{$screen-medium} {
            top: calc(100% + $gap-desktop-min / 2 - $size / 2);
            left: 50%;
            transform: translateX(-50%) rotate(90deg);
        }

        &-icon {
            transform: rotate(-90deg);
        }

        &--hidden {
            display: none;
        }
    }
}
</style>